import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { MY_DAY_ROUTE } from '../../services/routes';
import { useSyncSpaceMembershipMutation } from '../../app/smorgAppSyncGraphQLApi';
import {
  useGetCurrentSpaceMembershipQuery,
  useGetEndUserSpaceQuery,
} from '../../app/smorgAppSyncGraphQLApiCustomHooks';

const InitialProgrammeSelectionContainer = () => {
  const dispatch = useDispatch();

  const navigate = useNavigate();

  // const [searchParams] = useSearchParams();
  // const urlSpaceID = searchParams.get('intoSpace');
  // const accountSpaceID = useSelector(currentEndUserSpaceIDSelector);
  // const spaceID = urlSpaceID || accountSpaceID;

  const { data: currentSpaceMembership } = useGetCurrentSpaceMembershipQuery();

  const { data: currentSpace } = useGetEndUserSpaceQuery();

  const defaultSharedProgrammeID =
    currentSpace?.defaultSharedProgrammeIDForNewUsers;

  const [syncSpaceMembership] = useSyncSpaceMembershipMutation();

  useEffect(() => {
    if (currentSpaceMembership) {
      syncSpaceMembership({
        spaceMembershipID: currentSpaceMembership.id,
        onboardingAnswers: currentSpaceMembership.onboardingAnswers,
        onboardingAnswersLastUpdatedAt:
          currentSpaceMembership.onboardingAnswersLastUpdatedAt,
        customTargetCalories: currentSpaceMembership.customTargetCalories,
        welcomeVideoWatched: currentSpaceMembership.welcomeVideoWatched,
        initialProgrammeSelectionLastOfferedAt: new Date().toISOString(),
        chatNickname: currentSpaceMembership.chatNickname,
        showNutritionHeader: currentSpaceMembership.showNutritionHeader,
      });
    }

    if (!defaultSharedProgrammeID) {
      navigate(MY_DAY_ROUTE);
      return;
    }
    navigate(MY_DAY_ROUTE);
    // Allow the Back button in the shared programme onboarding wizard to work correctly
    navigate(`/shared_programmes/${defaultSharedProgrammeID}/onboard`);
  }, [
    currentSpaceMembership,
    currentSpaceMembership.id,
    defaultSharedProgrammeID,
    dispatch,
    navigate,
    syncSpaceMembership,
  ]);

  return '';
};

export default InitialProgrammeSelectionContainer;
